<template>

  <el-dialog
      title="分配"
      :visible.sync="isShowFenpei"
      width="700px"
      top="5vh"
      style="margin-top:20px;"
  >
    <el-input
        placeholder="输入关键字进行过滤"
        v-model="filterText"
        style="width: 40%; margin-left: 5%; margin-bottom: 5px;">
    </el-input>
    <el-tree
        :key="treeKey"
        :data="treeData"
        :props="treeProps"
        node-key="id"
        ref="tree"
        :filter-node-method="filterNode"
        style="margin-left: 48px"
    > <span class="custom-tree-node" slot-scope="{ node, data }">
          <span v-if="data.children">{{ data.name }}</span>
          <span v-else>
              <el-checkbox v-model="data.isCheckBox" :label="data.name" :key="data.id" @change="getCheckModule(data)"></el-checkbox>
          </span>
        </span>
    </el-tree>
    <div slot="footer" class="dialog-footer">
      <el-button @click="isShowFenpei = false">取 消</el-button>
      <el-button type="primary" @click="Submit">分配</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {ajaxPost, Baseurl} from "../../../api/api/api";

export default {
    data() {
      return {
        filterText: '',
        treeKey:0,
        selectNodeId:'',
        oldCheckObj:{},
        checkedEl:false,
        isShowFenpei:false,
        treeData: [],  //处理后的数据
        treeProps: {
          children: "children",  //子节点字段名
          label: "name"
        },
        ids:[]
      }
    },
		created() {
		},
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
    methods:{
      //筛选节点  返回true 显示，false，隐藏
      filterNode(value, data) {
        // if (!value) return true;
        return data.name.indexOf(value) !== -1;
      },
      getCheckModule(data){
        this.oldCheckObj.isCheckBox = false
        this.oldCheckObj = data
        this.selectNodeId = data.id
        let categoryIds = this.$refs.tree.getCheckedNodes(false, false).map(
            i => i.id
        )
      },
      //分配弹窗
      handleFenlei(treeData,ids){
        this.treeKey += 1
        this.treeData = JSON.parse(treeData)[0].children
        this.ids = ids
        this.isShowFenpei  = true
      },
      Submit(){
        console.log(this.oldCheckObj)
        let params = {
          ids:this.ids,
          categoryFullName:this.oldCheckObj.fullName,
          categoryId:this.selectNodeId
        }
        ajaxPost(
            Baseurl + '/baseProductController/updateCategoryByIds',
            params
        ).then((res) => {
          const { code, data } = res.data
          if (code === 200) {
            this.$message({
              type: 'success',
              message: '设置成功!',
            })
            this.isShowFenpei = false
            this.$emit("refresh")
          }
        })
      }
    }
	}
</script>

<style lang="scss" scoped>
	.Minister-top {
		width: 99%;
		border-radius: 4px;
		overflow: hidden;
    margin-bottom: 32px;

		.Ministerbackground {
			background: #d7f0dbff;
		}
		.Minister-top-top {
			width: 100%;
			height: 40px;

			.Minister-top-left {
				width: 80px;
				line-height: 40px;
				float: left;
				text-align: center;
				font-size: 16px;
				color: #fff;
			}

			.Minister-top-color {
				// color: #567801;
				background: #39b54a;
			}
		}
		.information_content {
			width: calc(100% - 22px);
			overflow: hidden;
			padding: 10px 10px;
			border: 1px solid rgba(168,168,168,0.8);
			border-bottom-left-radius: 10px;
			border-bottom-right-radius: 10px;
			border-top: none !important;
			margin-bottom: 15px;

			.information_Mandarin {
				overflow: hidden;
				// margin-left: 4%;
				display: flex;
				justify-content: space-between;

				ul {
					max-width: 1450px;
					flex: 1;
					display: flex;

					li {
						width: 90px;
						height: 35px;
						line-height: 35px;
						text-align: center;
						// float: left;
						cursor: pointer;
					}
					.liactive {
						background: #2c8dff;
						color: #fff;
					}
				}
			}
			.information_tips {
				line-height: 50px;
				margin-left: 10%;
				color: #f89a9a;
				font-size: 16px;
			}
			.information_input {
				overflow: hidden;
				position: relative;
				.region {
					width: 80px;
					height: 80px;
					background: rgba(0, 0, 0, 0);
					// background: red;
					position: absolute;
					left: 0px;
					top: 50px;
				}
				.information_Title {
					width: 8%;
					overflow: hidden;
					color: #7d7171;
					text-align: right;
					float: left;
					line-height: 33px;
					margin-right: 1%;
					font-weight: bold;
					user-select: none;
					.tips {
						color: red;
					}
				}
				.input_el {
					width: 88%;
					float: left;

					.Preservation {
						float: right;
						padding: 10px 10px;
						background: #73ade9;
						color: #fff;
						margin-top: 5px;
						border-radius: 5px;
					}
				}
			}
		}
	}
	.uploadPictures {
		/deep/ .el-upload-list__item {
			width: 178px;
			height: 178px;
		}
		/deep/ .el-upload--picture-card {
			width: 178px;
			height: 178px;
			line-height: 178px;
			padding: 0 20px;
		}
		/deep/ .selectUpload {
			// .el-upload.el-upload--picture-card,
			.el-upload-list__item-status-label {
				display: none;
			}
		}
		/deep/ .el-dialog__body {
			word-break: break-word;
		}
		.flip-list-move {
			transition: transform 0.5s;
		}
		.no-move {
			transition: transform 0s;
		}
		.ghost {
			opacity: 0.5;
			background: #c8ebfb;
		}
		.showImg {
			width: 148px;
			float: left;
			margin-right: 15px;
		}
	}
  .bianti {
    margin-left: 20px;
    font-size: 16px;
    margin-top: 12px;
    align-items: center;
    .shuxing_box{
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      .shuxing_box_item{
        margin-left: 20px;
        padding: 6px;
        display: flex;
        align-items: center;
      }
    }

  }

  .bianti_box{
    width: calc(100% - 22px);
    min-height: 120px;
    padding: 10px 10px;
    border: 1px solid rgba(168,168,168,0.8);
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    border-top: none !important;
    padding-bottom: 20px;
  }
  .scope_img_img{
    height: 80px;
    width: 80px;
    margin-left: 12px;
    border: 1px dashed darkgrey;
    border-radius: 8px;
    cursor: pointer;
  }
  .prduct_img{
    height: 550px;
    width: 550px;
  }
</style>
